import type { IconData } from '@stacksjs/iconify-core'

export const tk4x3: IconData = {
  "body": "<path fill=\"#00247d\" d=\"M0 0h640v480H0z\"/><path fill=\"#fed100\" d=\"M108.1 354.6c-6.7-.1 62.8-37 120.9-84.4c76.2-62.1 240.3-161.4 288.6-177.6c5-1.7-10.3 8.6-12.3 11.9c-51.5 61-10.4 176 54 233.9c19.4 14.8 18.4 15.6 54.3 17v3.4zm-4.2 6.7s-4.9 3.5-4.9 6.1c0 2.9 5.5 6.7 5.5 6.7l498.5 5.5l9.2-6.1l-12.8-7.9z\"/><path fill=\"#fff\" d=\"m106.8 109.1l-4 12.2l10.4-7.5l10.3 7.5l-3.9-12.2l10.3-7.5h-12.8l-3.9-12.2l-4 12.2H96.4zm78.1 57.4l8.6-6.3h-10.7l-3.3-10.1l-3.3 10.1h-10.6l8.6 6.3l-3.3 10.1l8.6-6.3l8.7 6.3zm-145.2 13l-4-12.2l-3.9 12.2H19l10.3 7.5l-3.9 12.2l10.3-7.5l10.4 7.5l-4-12.2l10.4-7.5zm78.1 122.3l-4.6-14.2l-4.6 14.2h-15l12.1 8.7l-4.6 14.3l12.1-8.8l12.1 8.8l-4.7-14.3l12.1-8.7z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default tk4x3
